import React from 'react';
import '../../../../static/styles/apiguide.scss';
import '../../../../static/styles/dashboard.scss';

export default class ViewSingleTourProduct extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div id = "view-single-tour-product">
                {/*<h3 className="mb0 mt40">1. 하나의 여행상품을 가져오는 API</h3>*/}
                <h3 className="mb0 mt40">단일 조회</h3>

                <div className="blog-post-meta">
                    <span className="s-post"> 상품 ID(travelProductId)로 등록된 상품을 조회합니다.</span>
                    <h3 className="request-method">
                        <span className="label label-primary">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/tours/{'{travelProductId}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td>data</td>
                            <td>TravelTourDto</td>
                            <td>응답 데이터 (여행상품 생성시 요청 값을 참조하시기 바랍니다.)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#collapse">Response Data Sample</a>
                        </div>
                        <div id = "collapse" className = "panel-collapse collapse">
                            <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "SUCCESS",
    "data": {
        "sellerProductId": "seller-product-id",
        "name": "[장가계]★BSET★효도여행 추천 6/7일 패키지",
        "adultOnly": false,
        "subordinateIds": null,
        "searchTags": [
            "중국장가계",
            "장가계여행"
        ],
        "displayKeyword": "인천出",
        "images": [
            {
                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",
                "sellerUrlMethod": "GET",
                "representative": true,
                "sellerImageCategory": "1234",
                "imageGroup": "BASIC",
                "description": "image 1 description",
                "seq": 0
            },
            {
                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
                "sellerUrlMethod": "GET",
                "representative": false,
                "sellerImageCategory": "1234",
                "imageGroup": "BASIC",
                "description": "image 2 description",
                "seq": 1
            },
            {
                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",
                "sellerUrlMethod": "GET",
                "representative": false,
                "sellerImageCategory": "1234",
                "imageGroup": "BASIC",
                "description": "image 3 description",
                "seq": 2
            },
            {
                "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",
                "sellerUrlMethod": "GET",
                "representative": false,
                "sellerImageCategory": "1234",
                "imageGroup": "BASIC",
                "description": "image 4 description",
                "seq": 3
            }
        ],
        "trafficInfo": "제주공항 차량 약 3km",
        "publicTransportInfo": "용두암 차량 약 1km",
        "nearbyLandmarks": [
            {
                "name": "nearby 1",
                "latitude": 10.1,
                "longitude": 20.2,
                "distance": 300,
                "distanceUnit": "METER",
                "direction": null,
                "transportations": []
            },
            {
                "name": "nearby 1",
                "latitude": 30.3,
                "longitude": 40.4,
                "distance": 2,
                "distanceUnit": "KILOMETER",
                "direction": null,
                "transportations": []
            }
        ],
        "locations": [
            {
                "latitude": 80.11,
                "longitude": 20.12,
                "roadNameAddress": "제주특별자치도 제주시 용해로 21-6",
                "landNumberAddress": "제주특별자치도 제주시 용담삼동 1016",
                "nation": "대한민국",
                "province": null,
                "city": "제주특별자치도",
                "district": "제주시",
                "town": "용담삼동",
                "zipCode": "63150"
            }
        ],
        "contents": [
            {
                "title": "product content title 1",
                "type": "Product-Content",
                "content": "product content 1: text",
                "format": "TEXT",
                "sellerUrl": null,
                "sellerUrlMethod": "GET",
                "seq": 0
            },
            {
                "title": "product content title 2",
                "type": "Product-Content",
                "content": null,
                "format": "IMAGE",
                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",
                "sellerUrlMethod": "GET",
                "seq": 1
            },
            {
                "title": "product content title 3",
                "type": "Product-Content",
                "content": null,
                "format": "IMAGE",
                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
                "sellerUrlMethod": "GET",
                "seq": 2
            },
            {
                "title": "product content title 2",
                "type": "Product-Content",
                "content": null,
                "format": "IMAGE",
                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",
                "sellerUrlMethod": "GET",
                "seq": 3
            }
        ],
        "features": [
            {
                "featureId": "ADDITIONAL_EXPENSE",
                "featureValues": [
                    "ADDITIONAL_EXPENSE_EXCLUDE"
                ],
                "description": null
            },
            {
                "featureId": "SHOPPING",
                "featureValues": [
                    "SHOPPING_INCLUDE"
                ],
                "description": null
            },
            {
                "featureId": "FREE_SCHEDULE",
                "featureValues": [
                    "FREE_SCHEDULE_EXCLUDE"
                ],
                "description": null
            }
        ],
        "themes": [
            "SIGHT_SEEING",
            "WATER_SPORTS"
        ],
        "reservationNotifications": [
            {
                "type": "PHONE",
                "contactInfo": "010-1234-5678",
                "contactDescription": "order notification phone number"
            },
            {
                "type": "EMAIL",
                "contactInfo": "coupang@coupang.com",
                "contactDescription": "order notification email"
            }
        ],
        "contacts": [
            {
                "contactType": "PHONE",
                "contactUseType": "REPRESENTATIVE",
                "contact": "02-1544-3663"
            },
            {
                "contactType": "PHONE",
                "contactUseType": "BOOKING_INQUIRY",
                "contact": "02-1544-3663"
            },
            {
                "contactType": "PHONE",
                "contactUseType": "EMERGENCY",
                "contact": "02-1544-3663"
            },
            {
                "contactType": "PHONE",
                "contactUseType": "CANCEL_INQUIRY",
                "contact": "02-1544-3663"
            }
        ],
        "itineraries": [
            {
                "name": "[장사/장가계 3박5일]",
                "notice": "※본 상품은 모두투어의 동일항공의 다른상품과 현지에서 조인(합류) 되어 진행될 수 있으며, 출발 1일전까지 일정 확정시 홈페이지 등을 통해 확인 가능합니다.\\n※본 상품은 예약시점에 따라 상품가가 상이할 수 있으며 금액 차이에 대해서는 추후 환불 하지 않습니다.\\n※일정상의 표기된 호텔은 현지 사정상 가능한 호텔이나 동급 호텔로 변경될 수 있습니다.\\n※장가계 일정 중 쇼핑센터 외 차량내 기념품 판매 및 농수산품 판매를 하며, 필요한 고객에 한하며 구매가능합니다.\\n※현지사정(기후, 도로등)에 따라 소비자의 동의를 얻어 여행일정 변경이 가능하며, 기상악화에 따라 일부 관광지가 제한될 수 있습니다.\\n---111111",
                "courses": [
                    {
                        "name": "1 일차 - 1",
                        "summary": "2019년 10월 14일 월요일 - 1",
                        "from": "인천 (ICN)출발 - 1",
                        "to": "중경 (CKG)도착 - 1",
                        "details": [
                            {
                                "type": "NOTICE",
                                "mealName": null,
                                "location": null,
                                "hotelName": null,
                                "flightFrom": null,
                                "flightTo": null,
                                "flightDepartureTime": "19:00:00",
                                "flightArrivalTime": "19:00:00",
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "중경 단체비자 입국시 유의 사항 - 1",
                                        "type": null,
                                        "content": "개요 : ◎ 중국 비자 입국 순서 ◎\\n1. 여권과 비자 원본을 확인 해 주시기 바랍니다.\\n-중국 비자 원본은 붉은색 도장이 찍혀 있습니다.\\n2. 비자 1번에 있는 손님께서 여권과 비자 원본, 복사본 1부를 입국심사대에 제출 합니다.\\n3. 비자에 나와 있는 순서대로 입국심사대를 통과합니다.\\n4. 비자 마지막에 있는 손님께서는 비자 원본을 받아 오셔야 합니다.\\n(비자 원본은 출국 시 제출합니다.)\\n---111111",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    }
                                ],
                                "seq": 0,
                                "feeIncluded": true,
                                "optional": false
                            },
                            {
                                "type": "FLIGHT",
                                "mealName": null,
                                "location": null,
                                "hotelName": null,
                                "flightFrom": "인천 (ICN)출발 - 1",
                                "flightTo": "중경 (CKG)도착 - 1",
                                "flightDepartureTime": "10-14 (월) 15:10",
                                "flightArrivalTime": "10-14 (월) 17:40",
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "Fight Title Required",
                                        "type": null,
                                        "content": "CA440편-03시간 30분 소요",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    }
                                ],
                                "seq": 1,
                                "feeIncluded": true,
                                "optional": false
                            },
                            {
                                "type": "MEAL",
                                "mealName": "석식",
                                "location": null,
                                "hotelName": null,
                                "flightFrom": null,
                                "flightTo": null,
                                "flightDepartureTime": null,
                                "flightArrivalTime": null,
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "Meal Title Required",
                                        "type": null,
                                        "content": "현지식",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    }
                                ],
                                "seq": 2,
                                "feeIncluded": true,
                                "optional": false
                            },
                            {
                                "type": "HOTEL",
                                "mealName": null,
                                "location": null,
                                "hotelName": null,
                                "flightFrom": null,
                                "flightTo": null,
                                "flightDepartureTime": null,
                                "flightArrivalTime": null,
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "Hotel Title Required",
                                        "type": null,
                                        "content": "총 2개의 예정 호텔이 있습니다. 확정 되는대로(출발 1일전까지) 홈페이지, 이메일 또는 알림톡 등을 통해 안내 드리겠습니다.",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    }
                                ],
                                "seq": 3,
                                "feeIncluded": true,
                                "optional": false
                            }
                        ]
                    },
                    {
                        "name": "2 일차",
                        "summary": "2019년 10월 15일 화요일",
                        "from": null,
                        "to": null,
                        "details": [
                            {
                                "type": "SIGHTSEEING",
                                "mealName": null,
                                "location": null,
                                "hotelName": null,
                                "flightFrom": null,
                                "flightTo": null,
                                "flightDepartureTime": null,
                                "flightArrivalTime": null,
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "보봉호",
                                        "type": null,
                                        "content": "보봉호수는 댐을 쌓아 물을 막아서 만든 인공호수로 주로 수력발전과 양식장으로 사용 되던 중 보봉호의 아름다움에 관광지로 개발되었습니다 해발 430m 위에 있는 산정호수로 평균수심은 72m이며 가장 넓은 곳의 폭은 150m에 이른다. 선녀바위, 두꺼비바위, 공작새바위 등과 같이 사람 혹은 짐승모양으로 되어있는 바위들이 보봉호의 아름다움을 더욱 신비스럽게 만들...",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 1
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 2
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 3
                                    }
                                ],
                                "seq": 0,
                                "feeIncluded": true,
                                "optional": false
                            },
                            {
                                "type": "SIGHTSEEING",
                                "mealName": null,
                                "location": null,
                                "hotelName": null,
                                "flightFrom": null,
                                "flightTo": null,
                                "flightDepartureTime": null,
                                "flightArrivalTime": null,
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "선택관광-황룡동굴($30)",
                                        "type": null,
                                        "content": "개요 : 군지평 동쪽으로 8km 떨어진 곳에 위치해 있다. 지각운동으로 인해 생성된 석회암 용암동굴로 상하 4층으로 되어 있고, 아래 2층에는 4개의 시내가 흘러내리는 동굴이다. 수직고도는 160m, 동굴 길이는 15km이며, 이미 개발되어 있는 면적이 6만평에 달한다. 또한 동굴 안에는 수많은 기이한 종유석이 천태만상을 보여주고 있다.",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 1
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 2
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 3
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 4
                                    }
                                ],
                                "seq": 1,
                                "feeIncluded": false,
                                "optional": true
                            },
                            {
                                "type": "SIGHTSEEING",
                                "mealName": null,
                                "location": null,
                                "hotelName": null,
                                "flightFrom": null,
                                "flightTo": null,
                                "flightDepartureTime": null,
                                "flightArrivalTime": null,
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "선택관광-유리다리+대협곡($95)",
                                        "type": null,
                                        "content": "개요 : 유리다리와 대협곡을 함게 볼 수 있는 선택관광",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 1
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "hhttp://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 2
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 3
                                    },
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": null,
                                        "format": "IMAGE",
                                        "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",
                                        "sellerUrlMethod": "GET",
                                        "seq": 4
                                    }
                                ],
                                "seq": 2,
                                "feeIncluded": false,
                                "optional": true
                            },
                            {
                                "type": "HOTEL",
                                "mealName": null,
                                "location": null,
                                "hotelName": null,
                                "flightFrom": null,
                                "flightTo": null,
                                "flightDepartureTime": null,
                                "flightArrivalTime": null,
                                "duration": null,
                                "distance": null,
                                "descriptions": [
                                    {
                                        "title": "Test Title",
                                        "type": null,
                                        "content": "총 2개의 예정 호텔이 있습니다. 확정 되는대로(출발 1일전까지) 홈페이지, 이메일 또는 알림톡 등을 통해 안내 드리겠습니다.",
                                        "format": "TEXT",
                                        "sellerUrl": null,
                                        "sellerUrlMethod": "GET",
                                        "seq": 0
                                    }
                                ],
                                "seq": 3,
                                "feeIncluded": true,
                                "optional": false
                            }
                        ]
                    }
                ]
            }
        ],
        "cancelPolicy": {
            "notice": "• 취소료는 쿠팡가(즉시할인 적용 전 상품가) 기준으로 부과됩니다.(여행사의 귀책 사유로 인한 취소의 경우에도 동일하게 적용됩니다.) • 즉시할인은 상황에 따라 예고없이 할인금액의 조정 및 조기종료 될 수 있습니다. • 즉시할인 이벤트가 종료된 후에는 기적용된 즉시할인 상품을 취소 후에 재구매하더라도 할인 적용이 유지되지 않습니다. • 본 상품은 예약 후 취소할 경우 여행약관 제5조 (특약)에 따라 표준약관과는 별도의 취소수수료가 적용됩니다. (이 상품은 항공(또는 선박)좌석 또는 호텔 객실에 대한 비용을 선납해 놓은 상품으로서, 취소시 별도의 취소수수료가 적용됨을 양해 바랍니다.) • 해피콜을 통해 예약 확정 후 여행자의 취소요청 시 업체가 정한 특별약관에 의거 취소료가 부과됩니다. (국외여행약관 제5조 특약) ☞ 취소수수료 특별 규정 (※ 전세기 상품 및 중국 민항기 상품 규정※) - 해피콜 확정 후 ~30일 이전 취소 위약금 20만원 - 여행개시 20일 전까지(29 ~ 20) 통보 : 여행요금의 30% 배상 - 여행개시 10일 전까지(19 ~ 10) 통보 : 여행요금의 55% 배상 - 여행개시   8일 전까지( 9 ~   8) 통보 : 여행요금의 85% 배상 - 여행개시   1일 전까지( 7 ~   1) 통보 : 여행요금의 90% 배상 - 여행 당일 통보 시 : 여행요금의 100% 배상",
            "cancelType": "APPROVAL",
            "cancelPeriodType": "BEFORE_USE",
            "cancelMarkType": "DEPENDING_ON_VENDOR",
            "refundOnBusinessDay": true,
            "refundUnusedTicket": true,
            "refundRates": [
                {
                    "conditionDays": 5,
                    "conditionTime": "17:00",
                    "refundRate": 100,
                    "cancellable": false
                },
                {
                    "conditionDays": 3,
                    "conditionTime": "17:00",
                    "refundRate": 70,
                    "cancellable": false
                },
                {
                    "conditionDays": 1,
                    "conditionTime": "17:00",
                    "refundRate": 50,
                    "cancellable": false
                }
            ]
        },
        "introduction": "장가계 항공이동&버스이동 선택가능",
        "notice": "날짜당 성인기준 10명 이상 모객 시 출발확정 가능",
        "benefits": [
            "Special Offer 1",
            "Special Offer 2"
        ],
        "flightInfo": {
            "title": "Flight Information",
            "type": "Flight Info",
            "content": "항공편:중국국제항공\\n무료위탁수하물:1pc 23kg [단, 산동노선(청도, 제남, 위해, 연태)은 2pc 23kg]\\n허용기내수하물:1pc 5kg\\n",
            "format": "TEXT",
            "sellerUrl": null,
            "sellerUrlMethod": "GET",
            "seq": 0
        },
        "visaInfo": {
            "title": "비 자",
            "type": "VISA Info",
            "content": null,
            "format": "IMAGE",
            "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",
            "sellerUrlMethod": "GET",
            "seq": 0
        },
        "meetingPlace": "인천국제공항 1터미널 3층 출국장 14번 출구 앞(N카운터 옆 창측) 여행사카운터 38~42번 테이블",
        "meetingTime": "2019-11-01 12:30:00",
        "meetingNotice": {
            "title": "Map - Meeting Point",
            "type": "Meeting Notice",
            "content": null,
            "format": "IMAGE",
            "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",
            "sellerUrlMethod": "GET",
            "seq": 0
        },
        "guideInfo": "인솔자는 동반하지 않습니다",
        "shoppingInfo": {
            "details": [
                {
                    "shoppingCategory": "라텍스",
                    "shoppingPlace": "무릉원 천자거리 대지라텍스",
                    "duration": "약 7-80분",
                    "refundable": false
                },
                {
                    "shoppingCategory": "진주",
                    "shoppingPlace": "천문1호 양상 박람중심",
                    "duration": "약 60분",
                    "refundable": false
                },
                {
                    "shoppingCategory": "히노끼",
                    "shoppingPlace": "무릉원 보봉산장 내 히노끼 매장",
                    "duration": "약 60분",
                    "refundable": false
                },
                {
                    "shoppingCategory": "게르마늄",
                    "shoppingPlace": "무릉원구 백로로 건설은행 후원",
                    "duration": "약 60분",
                    "refundable": true
                }
            ],
            "exchangeRefundNotice": {
                "title": null,
                "type": "Exchange Refund Notice",
                "content": "? 환불접수기간 : 여행종료 후 30일 이내\\n? 환불가능물품 : 지정된 쇼핑장소에서 구매한 물품,개인 구매 물품 혹은 단순 고객 변심의 교환/환불 대행 불가\\n? 환불요청방법 : 여행상품명,출발일,인솔자명,간단한 사유를 대리점 혹은 예약담당자에게 유선 문의 후 조치\\n? 환불필요서류 : 본인 연락처/통장번호(수취인 본인만 가능),원본 영수증(사본 보관 필수),환불 혹은 교환 요청 물품\\n? 환불배송비부담 : 고객본인\\n? 환불소요기간 : 접수일로부터 최소 15일 ~ 최대 60일\\n◎환불시 주의사항◎\\n-환불수수료: 카드결제인 경우 환불시 카드수수료 5% 부과 (환불수수료는 상품 및 쇼핑점 기준에 따라 상이하며, 영수증 미지참시 환불 불가)\\n-유의사항\\n1)보석류\\n성분함량이 미달되는 제품이 많으니, 고가의 상품은 구입을 자제하여 주시기 바랍니다.\\n2)라텍스\\n포장이 제거되지 않은 제품일경우 100% 환불 가능합니다.\\n30일 이내에 단순변심으로 인한 환불시 구매금액의 30% 환불수수료 발생\\n90일 이내에 단순변심으로 인한 환불시 구매금액의 50% 환불수수료 발생\\n현지에서 배송받는 경우 별도의 배송비가 부과\\n3)게르마늄\\n환불시 알레르기 발생은 구매일로부터 7일 내에 환불신청, 그 외의 환불은 구매일로부터 15일 내에 환불 신청\\n환불시 5% 카드수수료 + 10% 위약금 발생\\n도금변색은 A/S 불가\\n4)농수산물(깨,잣 등)\\n교환 및 환불 절대 불가\\n",
                "format": "TEXT",
                "sellerUrl": null,
                "sellerUrlMethod": "GET",
                "seq": 0
            }
        },
        "tourGuides": [
            {
                "title": "선택관광 안내",
                "type": "Tour Guide",
                "content": "1. 선택관광 및 자유시간 중 고객님의 안전을 위하여 가이드의 안내사항 및 안전수칙을 준수하여 모든 안전사고에 유의하시기 바랍니다.\\n2. 현지 선택관광은 가이드의 주의사항을 숙지 후 참여 여부를 결정하여 주시기 바라며, 참여 전 반드시 배포되는 안전수칙 동의서를 숙지 및 동의 후 참여하시기 바랍니다.\\n3. 이용자 본인의 과실 및 건강상태로 인하여 발생한 안전사고에 대하여 당사는 책임을 지지 않습니다.\\n4. 선택관광은 고객님이 자유롭게 지불여부를 결정할 수 있으며 선택관광에 참여하지 않음으로 인한 추가적인 비용 또는 일정상의 불이익은 없습니다.\\n",
                "format": "TEXT",
                "sellerUrl": null,
                "sellerUrlMethod": "GET",
                "seq": 0
            },
            {
                "title": "Tour Guide",
                "type": "Tour Guide",
                "content": "◇ 미팅장소 : 인천국제공항 제1터미널 3층 N카운터(14번 출입문) 앞 <투어2000> 테이블 미팅\\n◇ 인천공항 : 인천공항 연락처 010-2742-6200\\n◇ 최소 출발 인원 : 성인10명 이상 출발 가능합니다.\\n◇ 출발인원이 부족할 경우 타사와 공동 진행 될 수 있습니다.\\n◇ 인솔자는 동행하지 않으며, 현지 도착 후 가이드와 미팅 합니다.\\n◇ 독실사용료 : 1박 40,000원(전 일정 3박 120,000원) 입니다.\\n- 호텔: 2인1실 기준이며, 3인실 이용시 간이침대가 제공 됩니다.\\n- 여행 하시는 인원이 홀수인 경우 별도의 요청이 없으실 경우 3인1실로 배정 됩니다.\\n◇ 자유일정 : 패키지일정의 특성상 개별일정 불가합니다.\\n◇ 일정 진행 중 쇼핑점 방문이 있습니다.(*쇼핑정보 참조)\\n◇ 여행자 보험은 'DB 손해보험'으로 자동 가입 됩니다. (*여행자보험 참조)\\n◇ 본 여행상품은 계약금 지불 시점부터 계약이 체결되며, 계약 해제 요청 시 귀책사유에 따라 취소수수료가 부과됩니다. 취소수수료 부과기준은 [국외여행표준약관/특별약관]에 따릅니다.\\n◇ 상기 일정은 항공 및 현지사정에 의하여 변경될 수 있습니다.\\n◇ 유류할증료는 예약시점이 아닌 발권일 기준으로 적용되며, 국제유가와 항공사 영업환경을 고려한 건설교통부의 국제선 항공요금과 유류할증료 확대방안에 따라 예고없이 인상되거나 인하될 수 있습니다.\\n",
                "format": "TEXT",
                "sellerUrl": null,
                "sellerUrlMethod": "GET",
                "seq": 1
            }
        ],
        "safetyInstructions": [
            {
                "title": "여행금지국가 현황 및 법적근거",
                "type": "Safety Instruction",
                "content": "● 여행금지국가 지정 현황\\n외교부는 우리 국민의 생명·안전을 보호하기 위하여 여권법 제 17조에 따라 아래의 국가들은 지정된 기간 동안 여행금지국으로 지정하여 우리 국민들의 방문 및 체류를 금지합니다.\\n- 이라크(2007년 8월 7일 ~ 2017년 1월31일까지)\\n- 소말리아·아프가니스탄(2007년 8월 7일 ~ 2017년 1월 31일까지)\\n- 예멘(2011년 6월 28일 ~ 2017년 1월 31일까지)\\n- 시리아(2011년 8월 20일 ~ 2017년 1월 31일까지)\\n- 리비아(2014년 8월 4일 ~ 2017년 1월 31일까지)\\n- 필리핀 일부지역(잠보앙가, 술루 군도, 바실란, 타위타위 군도) (2015년 12월 1일 ~ 2017년 1월 31일까지)\\n● 법적근거\\n- 여권법 17조(여권의 사용제한 등)\\n외교부장관은 천재지변·전쟁·내란·폭동·테러 등 대통령령으로 정하는 국외 위난상황(危難狀況)으로 인하여 국민의 생명·신체나 재산을 보호하기 위하여 국민이 특정 국가나 지역을 방문하거나 체류하는 것을 중지시키는 것이 필요하다고 인정하는 때에는 기간을 정하여 해당 국가나 지역에서의 여권의 사용을 제한하거나 방문·체류를 금지 (이하 \\"여권의 사용제한 등\\"이라 한다)할수 있다. 다만, 영주(永住), 취재·보도, 긴급한 인도적 사유, 공무 등 대통령령으로 정하는 목적의 여행으로서 외교부장관이 필요하다고 인정하면 여권의 사용과 방문·체류를 허가할 수 있다.\\n- 여권법 제26조 제17조제1항 본문 및 제2항에 따라 방문 및 체류가 금지된 국가나 지역으로 고시된 사정을 알면서도 같은 조 제1항 단서에 따른 허가(제14조제3항에 따라 준용되는 경우를 포함한다)를 받지 아니하고 해당 국가나 지역에서 여권 등을 사용하거나 해당 국가나 지역을 방문하거나 체류한 사람은 1년 이하의 징역 또는 1000만원 이하의 벌금에 처한다.\\n",
                "format": "TEXT",
                "sellerUrl": null,
                "sellerUrlMethod": "GET",
                "seq": 0
            },
            {
                "title": "여행지(국가/지역) 여행경보 발령현황",
                "type": "Safety Instruction",
                "content": "● 중국\\n- 여행유의(일부) : 중국ㆍ북한 국경지역 : 단둥시, 관전만족자치현, 집안시, 백산시, 임강시, 장백조선족자치현, 안도현, 화룡시, 용정시, 도문시, 훈춘시\\n- 여행자제(일부) : 티벳, 신장위구르자치구\\n외교부는 우리 국민의 생명·안전을 보호하기 위하여 여권법 제 17조에 따라 아래의 국가들은 지정된 기간 동안 여행금지국으로 지정하여 우리 국민들의 방문 및 체류를 금지합니다.\\n※ 여행경보단계는 여행유의/자제/제한/금지 4단계로 구분되며, 외교부 '해외안전여행' 사이트(www.0404.go.kr)에서 상세정보를 확인 할 수 있습니다.\\n또한 출국 전 동사이트의 해외여행 등록제 \\"동행\\"에 가입하시면 안전정보를 수시로 제공 받을 수 있습니다.\\n",
                "format": "TEXT",
                "sellerUrl": null,
                "sellerUrlMethod": "GET",
                "seq": 1
            }
        ],
        "hotelInfo": {
            "title": "Hotel Information",
            "type": "Hotel Information",
            "content": "• 호텔명 :\\n• 등급 : \\n• 룸타입 : \\n• 1인 싱글 룸 사용시 :\\n- 호텔은 부득이한 경우 동급의 다른 호텔로 변동 될 수 있습니다.\\n",
            "format": "TEXT",
            "sellerUrl": null,
            "sellerUrlMethod": "GET",
            "seq": 0
        },
        "insuranceInfo": null,
        "inclusionNotice": "왕복 항공권 포함 -\\n유류할증료 및 각종 TAX(왕복공항세, 전쟁보험료, 관광진흥개발기금 등) 포함:   XXX항공 00,\\n000 원(성인 / 소아 동일) -\\n유류할증료는 국제 유가 및 IATA국제항공수송협회의 공시 환율에 따라 변동 될 수 있음. 변동에 따라 추가요금이 발생될 수 있으며,\\n추가요금 발생의 경우 해피콜시 안내드립니다.•전 일정 숙박 비용(성인 2 인 1 실 기준)• 일정표상 기제된 관광지 입장료 및 식사• 일정 중 전용차량 및 기사• 여행자 보험• 각종 특전 제공(컨텐츠 상세페이지 참조)\\n---111111",
        "exclusionNotice": "1 인당 전일정 $00 (0 박0일) 의 가이드 / 기사 경비 현지 지불(성인 / 아동 동일)• 선택 관광 경비 및 기타 개인경비 -\\n선택 관광은 자유의사로 미 선택에 따른 불이익 및 추가금은 없습니다.\\n---111111",
        "usageNotice": "아동(24 개월이상~만12세미만) 요금: 성인과 동일 -\\n항공 좌석 있음,\\n성인과 한방 사용• 유아(24 개월미만) 요금: 000,\\n000 원 / 인 -\\n별도의 항공좌석 없음,\\n노베드 조건(여행사에 직접 결제) • 여권 유효기간은 6 개월 이상 남아 있어야 합니다.•단수여권의 경우 별도 문의 부탁 드립니다.•해피콜시 여행사에 정확한 여권상의 영문이름을 알려주셔야 합니다.•본 상품은 쇼핑센터 0 회(XX, XX, XX 중 0 회) 방문 예정\\n---111111",
        "reservationGuide": {
            "title": null,
            "type": "Reservation Guide",
            "content": "• 출발조건\\n-  날짜당 성인기준 0명 이상 모객 시 출발확정 가능\\n- 쿠팡과 업체의 모객인원을 합산한 최소인원\\n- 최소인원 미달 시 출발 7일전까지 여행 취소 통지\\n• 여행지 안전정보: 국가별 여행경보 단계 보기 (http://www.0404.go.kr/dev/main.mofa)",
            "format": "TEXT",
            "sellerUrl": null,
            "sellerUrlMethod": "GET",
            "seq": 0
        },
        "additionalInfoPrompt": "please leave your phone number,dob,name and gender",
        "maxPurchaseQuantity": 1000,
        "csContactInfo": "평일 09: 00~18: 00(단, 토 / 일, 공휴일은 휴무)",
        "taxType": "FREE",
        "instantBooking": false,
        "estimatedBookingDuration": 1,
        "extension": null,
        "travelProductId": 205649217090228224,
        "productId": 347225867,
        "vendorItemPackageId": 100000048987,
        "productDetailType": "PACKAGE_TOUR",
        "travelType": "OVERSEAS",
        "displayCategoryCode": 108682,
        "vendorId": "A00177491",
        "saleStatus": "ON_SALE",
        "qcStatus": "COMPLETE_APPROVAL",
        "displayChannels": null,
        "userAgreements": null,
        "reservationRequired": false,
        "errors": [
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": null,
                "type": "IMAGE_PROCESS",
                "level": "MINOR"
            },
            {
                "info": "Duplicate key {\\"interlockingVendorItemId\\": \\"0\\", \\"interlockingRateCategoryId\\": \\"205649217534828544\\", \\"interlockingTravelItemId\\": \\"205660229461880832\\"}",
                "type": "CATALOG_INTEGRATION",
                "level": "MINOR"
            }
        ],
        "travelItems": [
            {
                "sellerTravelItemId": "seller-item-id-1",
                "name": "[장사/장가계] 3박5일",
                "description": "[장사/장가계] 3박5일 description",
                "period": "3박5일",
                "seq": 0,
                "features": [
                    {
                        "featureId": "AIRLINE_SHIP_TYPE",
                        "featureValues": [
                            "FOREIGN_AIRLINE"
                        ],
                        "description": null
                    },
                    {
                        "featureId": "TRAVEL_PERIOD",
                        "featureValues": [
                            "FIVE_DAYS"
                        ],
                        "description": null
                    },
                    {
                        "featureId": "DOMESTIC_DEPARTING_CITY",
                        "featureValues": [
                            "SEOUL_INCLUDE_INCHOEN_AND_KIMPO"
                        ],
                        "description": null
                    },
                    {
                        "featureId": "CONFIRMED_DEPART",
                        "featureValues": [
                            "DEPARTURE_UNDECIDED"
                        ],
                        "description": null
                    },
                    {
                        "featureId": "HOTEL_GRADE",
                        "featureValues": [
                            "FIVE_STAR"
                        ],
                        "description": null
                    },
                    {
                        "featureId": "FUEL_SURCHARGE_TAX",
                        "featureValues": [
                            "FUEL_SURCHARGE_INCLUDED"
                        ],
                        "description": null
                    },
                    {
                        "featureId": "DEPARTURE_OVERSEA_TIME",
                        "featureValues": [
                            "EVENING"
                        ],
                        "description": null
                    }
                ],
                "taxType": "FREE",
                "onSale": false,
                "rates": [
                    {
                        "sellerRateId": "seller-rate-id-1",
                        "rateType": "BASIC",
                        "priceType": "COUPANG_PRICE",
                        "price": 500000,
                        "representative": true,
                        "saleStartedAt": "2019-11-01 01:00:00",
                        "saleEndedAt": "2019-11-21 01:00:00",
                        "maxPurchaseQtyPerPerson": 10,
                        "maxPurchaseQtyPeriod": 1,
                        "seq": 0
                    }
                ],
                "travelItemId": 205649217492889600,
                "deleted": false
            },
            {
                "sellerTravelItemId": "seller-item-id-2",
                "name": "[장사/장가계] 4박6일",
                "description": "[장사/장가계] 4박6일 description",
                "period": "4박6일",
                "seq": 1,
                "features": [],
                "taxType": "FREE",
                "onSale": true,
                "rates": [
                    {
                        "sellerRateId": "seller-rate-id-1",
                        "rateType": "ADULT",
                        "priceType": "COUPANG_PRICE",
                        "price": 5000000,
                        "representative": true,
                        "saleStartedAt": "2019-11-01 01:00:00",
                        "saleEndedAt": "2019-12-21 01:00:00",
                        "maxPurchaseQtyPerPerson": 10,
                        "maxPurchaseQtyPeriod": 1,
                        "seq": 0
                    },
                    {
                        "sellerRateId": "seller-rate-id-1",
                        "rateType": "CHILD",
                        "priceType": "COUPANG_PRICE",
                        "price": 4000000,
                        "representative": true,
                        "saleStartedAt": "2019-11-01 01:00:00",
                        "saleEndedAt": "2019-12-21 01:00:00",
                        "maxPurchaseQtyPerPerson": 10,
                        "maxPurchaseQtyPeriod": 1,
                        "seq": 1
                    }
                ],
                "travelItemId": 205649217522237440,
                "deleted": false
            },
            {
                "sellerTravelItemId": "seller-item-id-5",
                "name": "[장사/장가계] 4박6일",
                "description": "[장사/장가계] 4박6일 description",
                "period": "4박6일",
                "seq": 1,
                "features": [],
                "taxType": "FREE",
                "onSale": true,
                "rates": [
                    {
                        "sellerRateId": "seller-rate-id-1",
                        "rateType": "ADULT",
                        "priceType": "COUPANG_PRICE",
                        "price": 5000000,
                        "representative": true,
                        "saleStartedAt": "2019-11-01 01:00:00",
                        "saleEndedAt": "2019-12-21 01:00:00",
                        "maxPurchaseQtyPerPerson": 10,
                        "maxPurchaseQtyPeriod": 1,
                        "seq": 0
                    },
                    {
                        "sellerRateId": "seller-rate-id-1",
                        "rateType": "CHILD",
                        "priceType": "COUPANG_PRICE",
                        "price": 4000000,
                        "representative": true,
                        "saleStartedAt": "2019-11-01 01:00:00",
                        "saleEndedAt": "2019-12-21 01:00:00",
                        "maxPurchaseQtyPerPerson": 10,
                        "maxPurchaseQtyPeriod": 1,
                        "seq": 1
                    }
                ],
                "travelItemId": 205660229461880832,
                "deleted": false
            }
        ],
        "createdBy": "1.24.57.16",
        "createdAt": "2019-12-04 18:48:27",
        "modifiedBy": "SYSTEM",
        "modifiedAt": "2019-12-04 19:32:15"
    }
}
                        `}

                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/V1/ProductAPI/ViewSingleTourProduct.jsx